import { useState } from "react";
import { useSendTransaction, useWaitForTransactionReceipt } from "wagmi";
import { useTransactionReceipt } from "wagmi";

export const useFoundrySendTransaction = () => {
  const {
    data: hash,
    isPending,
    sendTransaction,
    error,
    isError,
  } = useSendTransaction();
  const {
    isLoading: isConfirming,
    isSuccess: isConfirmed,
    status,
    error: receiptError,
  } = useWaitForTransactionReceipt({
    hash,
  });
  const result = useTransactionReceipt({
    hash,
  });

  console.log("Confirming...", isConfirming);
  console.log("Hash...", hash);
  console.log("Confirmed...", isConfirmed);
  console.log("reciept", result);
  const sendWeb3Transaction = async (payload: any) => {
    sendTransaction(payload);
  };

  return {
    isError,
    error,
    status,
    receiptError,
    isConfirming,
    isConfirmed,
    isPending,
    hash,
    sendWeb3Transaction,
    reciept: result,
  };
};
